// DOCS : https://redux-toolkit.js.org/usage/usage-with-typescript#createslice

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { shouldOpenDrawer } from 'utils/app-helpers';

const lg = 1200;

/**
 * App State
 */
type AppState = {
    drawerOpen: boolean;
};

/**
 * Initial App State
 */

const initialState: AppState = {
    drawerOpen: shouldOpenDrawer(lg),
} as AppState;

/**
 * App Slice
 */
const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        reset: () => initialState,
        setDrawerOpen: (state: AppState, action: PayloadAction<boolean>) => {
            state.drawerOpen = action.payload;
        },
    },
    selectors: {
        selectDrawerOpen: (state) => state.drawerOpen,
    },
});

export const appActions = appSlice.actions;
export const { selectDrawerOpen } = appSlice.selectors;
export default appSlice.reducer;
